<template>
    <div class="loader" v-if="(inModal && appModalOpen && !doNotUsePreloader) || (!inModal && !appModalOpen && !doNotUsePreloader)" :class="{'done': (appStatus == 'ready' && fileDownloading == false && !doNotUsePreloader)}">
        <font-awesome-icon icon="spinner" class="spinner"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "preloader",
  props: {
    inModal: false
  },
  created() {
    this.$log.info(process.env.VUE_APP_ENV);
  },
  computed: {
    ...mapGetters([
      'appStatus',
      'appModalOpen',
      'fileDownloading',
      'doNotUsePreloader'
    ])
  }
};
</script>